import React, { useEffect, useState } from 'react';
import { Button, Header, Input } from '../../components';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { IoIosSave, IoIosSearch, IoMdCloseCircle } from 'react-icons/io';
import { GrWorkshop } from 'react-icons/gr';
import TabHead from '../../components/TabHead';
import HourLoading from '../../components/HourLoading';
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import AddReglementEnseignant from './AddReglementEnseignant';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';

const CompteEnseignant = ({ selectedEnseignant, onClose }) => {
  const [loading, setLoading] = useState(false);

  const { token, setToken } = useStateContext();
  const [errors, setErrors] = useState([]);
  const [showAddReglement, setShowAddReglement] = useState(false);
  const [reglements, setReglements] = useState([]);
  const [enseignant, setEnseignant] = useState({
    montant: selectedEnseignant.montantParHeure,
    tel: selectedEnseignant.tel,
    matricule: selectedEnseignant.matricule,
    enseignant: selectedEnseignant.nom,
    enseignantId: selectedEnseignant.id,
    solde: selectedEnseignant.solde,

  });
  const [req, setReq] = useState({
    DateDebut: '',
    DateFin: ''
  });
  const navigate = useNavigate();

  const getLast10 = () => {
    setLoading(true);
    axiosClient.get('/reglementEnseignant/last10?enseignant=' + selectedEnseignant.id + '&DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin)
      .then((data) => {
        setReglements(data.data.reglements);
        setLoading(false);
      }).catch(err => {
        const response = err.response;
        if (response.status === 401) {
          setToken(null);
        }
        else {
          if (response.status === 422) {
            setErrors(response.data.errors);
            setLoading(false);
            toast.error('Une erreur est survenue!', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }

        }
      })
  }
  const supprimer = (reglement) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/reglementEnseignant/' + reglement.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getLast10();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }
  const closeAddReglement = () => {
    setShowAddReglement(false);
  }
  useEffect(() => {

  }, []);

  return (
    <>
      <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
        <div className='h-screen flex justify-center items-center'>
          <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
            <div className='flex w-full justify-between'>
              <div className="flex">
                <Header icon={<GrWorkshop />} title="Compte Enseignant" titleAr={"حساب المعلم"} />
              </div>
              <div className="text-red-500 text-lg">
                <IoMdCloseCircle size={30} onClick={() => onClose()} />
              </div>
            </div>

            {errors &&
              Object.keys(errors).map(key => (
                <Alert key={key} message={errors[key][0]} />
              ))
            }

            <div className='flex w-full gap-2'>
              <div className='flex flex-col gap-2 mr-2 '>
                <Input label="Matricule" labelAr={"رقم التسجيل"} type="number" value={enseignant.matricule} required="required" />
                <Input label="Nom" labelAr={"الاسم"} type="text" value={enseignant.enseignant} required="required" />
                <Input label="Telephone" labelAr={"الهاتف"} type="text" value={enseignant.tel} required="required" />
                <Input label="Solde" labelAr={"حساب"} type="text" value={enseignant.solde} required="required" />
              </div>
              <div className='flex flex-col gap-2 mr-2 '>
                <div className='mt-3 w-full overflow-x-auto'>
                  <div className="flex flex-col">
                    <div className="mb-2">
                      <Button onClick={() => { setShowAddReglement(true) }} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                    </div>
                    <div className="flex gap-2">
                      <Input label="Date debut" labelAr="من" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} required="required" />
                      <Input label="Date fin" labelAr="الى" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} required="required" />

                      <div className=' flex gap-2 mt-8'>
                        <Button onClick={() => getLast10()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                      </div>

                    </div>
                    <div className="flex my-2">
                      <h1 className='text-red-500 font-bold'>Total: {reglements.reduce((n, { montant }) => n + parseFloat(montant), 0)} MRU</h1>
                    </div>
                  </div>
                  {loading ? <HourLoading /> :
                    (
                      <table className='table-auto'>
                        <thead>
                          <tr>
                            <th><TabHead left="Date" right="التاريخ" />  </th>
                            <th><TabHead left="Montant" right="قيمة" />  </th>
                            <th><TabHead left="Actions" right={"إجراء"} /></th>
                          </tr>
                        </thead>
                        <tbody>
                          {reglements && reglements.map(o => (
                            <tr key={o.id}>
                              <td>{o.dateReglement}</td>
                              <td>{o.montant}</td>
                              <td>
                                <ActionButton onClick={() => { supprimer(o) }} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Supprimer" />
                              </td>
                            </tr>
                          ))

                          }
                        </tbody>
                      </table>
                    )

                  }

                </div>
                {showAddReglement ? <AddReglementEnseignant selectedEnseignant={selectedEnseignant} onClose={closeAddReglement} /> : <></>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CompteEnseignant